import { useEffect } from "react";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { History } from "history";

interface ScrollToTopProps extends RouteComponentProps {
  history: History;
}

function ScrollToTop({ history }: ScrollToTopProps) {
  useEffect(() => {
    const unlisten = history.listen(() => {
      window.scrollTo(0, 0);
    });
    return () => {
      unlisten();
    };
  }, [history]);

  return null;
}

export default withRouter(ScrollToTop);
